import type { SVGProps } from 'react';

const SvgUnecrypted = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 0.398438C3.87695 0.398438 2.83203 1.04297 2.48047 2.35156C2.47559 2.37109 2.47559 2.38086 2.4707 2.39551L3.26172 3.19141C3.26172 3.15723 3.2666 3.12793 3.2666 3.09375C3.35449 1.94629 4.0918 1.30664 5 1.30664C5.95703 1.30664 6.74316 2.00977 6.74316 3.34277V4.60742L4.68262 4.6123L8.46191 8.3916V5.66211C8.46191 5.02734 8.20801 4.69531 7.69043 4.62207V3.43555C7.69043 1.38477 6.3916 0.398438 5 0.398438ZM9.10645 11.0186C9.25781 11.1699 9.51172 11.1699 9.6582 11.0186C9.80469 10.8623 9.80957 10.623 9.6582 10.4668L1.0498 1.86816C0.898438 1.7168 0.649414 1.71191 0.493164 1.86816C0.34668 2.01465 0.34668 2.26855 0.493164 2.41504L9.10645 11.0186ZM2.53418 10.5059H7.51953C7.59766 10.5059 7.6709 10.501 7.73438 10.4912L1.97754 4.73438C1.66016 4.89551 1.5332 5.20312 1.5332 5.69629V9.45117C1.5332 10.1738 1.86523 10.5059 2.53418 10.5059Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgUnecrypted;
